module.exports = __webpack_public_path__ + "static/media/Quizz_text.a72548a2.svg";